<div *ngIf="!isEditing" (click)="startEditing()" class="click-to-edit-area">
    {{ currentValue || '' }}
</div>

<div *ngIf="isEditing">
    <nz-select
        #selectComponent
        [(ngModel)]="currentValue"
        [(nzOpen)]="openMenu"
        [nzMode]="isRestrained ? 'default' : 'multiple'"
        [nzAllowClear]="true"
        style="width: 100%"
        (ngModelChange)="changeSelect($event)"
        (nzOpenChange)="openChange($event)"
    >
        <nz-option *ngFor="let option of options" [nzValue]="option"
                   [nzLabel]="option"></nz-option>
    </nz-select>
</div>
